import { createRemoveSyncSlice } from '@sonar-software/xuder';
import { getCoreApiGatewayKeysSlice } from './get';

export const coreApiGatewayKeysRemoveSyncSlice = createRemoveSyncSlice({
	name: 'CoreApiGatewayKeys',
	state: getCoreApiGatewayKeysSlice.asyncState,
	transform: (action: { apiKeyId: number }, state) => ({
		apiGatewayKey: state?.apiGatewayKey.filter((key) => action.apiKeyId !== key.id) ?? []
	})
});
